module.exports = __webpack_public_path__ + "img/projeto_vivo_acordos_de_cobranca3.1a59d288.jpg";